import React from 'react'

export const Dialog = ({mensaje, type, closeDialog}) => {
  return (
      <div className="overlay" style={{opacity:1}}>
            <div className="dialogBox">
                <div className="caja">
                {mensaje}
                </div> 
                <button
                    className="btnClose"
                    onClick={closeDialog}
                >
                    Continuar
                </button>
            </div>
              
          
      </div>
  )
}
